import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['nameInput', 'emailInput', 'docFileInput', 'isAgreeInput'];

  checkFile(evt) {
    const fileSize = evt.target.files[0].size;
    const maxSize = 1024 * 1024; //10mb  // 1024*1024 = 1048579 = 1mb
    if (fileSize <= maxSize) {
      return;
    }
    const msg = `${maxSize / 1048576} MB 이하의 파일만 업로드 가능합니다.`;
    document.getElementById(evt.target.id).value = '';
    window.$sendAlert(msg);
  }

  validate(evt) {
    if (this.nameInputTarget.value === '') {
      window.$sendAlert('이름을 작성해주세요');
      evt.preventDefault();
    }
    if (this.checkSpecial(this.nameInputTarget.value)) {
      window.$sendAlert('이름에는 특수문자를 포함할 수 없습니다');
      evt.preventDefault();
    }
    if (this.checkNum(this.nameInputTarget.value)) {
      window.$sendAlert('이름에는 숫자를 포함할 수 없습니다');
      evt.preventDefault();
    }
    if (this.nameInputTarget.value.length > 20) {
      window.$sendAlert('이름은 20자 이상 넘을 수 없습니다');
      evt.preventDefault();
    }
    if (this.emailInputTarget.value === '') {
      window.$sendAlert('이메일을 작성해주세요');
      evt.preventDefault();
    }
    if (!this.isAgreeInputTarget.checked) {
      window.$sendAlert('개인정보 수집 및 활용 동의가 필요합니다');
      evt.preventDefault();
    }
    if (this.hasDocFileInputTarget && this.docFileInputTarget.value === '') {
      window.$sendAlert('신청서 파일 업로드가 필요합니다');
      evt.preventDefault();
    }
  }

  checkSpecial(str) {
    const regExp = /[{}[\]/?.,;:|)*~`!^\-_+<>@#$%&\\=('"]/g;
    return regExp.test(str);
  }

  checkNum(str) {
    const regExp = /[0-9]/g;
    return regExp.test(str);
  }
}
